import { ACCOMMODATION_SERVICES_SECTOR, ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR, ARTS_ENTERTAINMENT_SECTOR, CONSTRUCTION_SECTOR, EDUCATIONAL_SERVICES_SECTOR, FINANCE_AND_INSURANCE_SECTOR, FISHING_AND_HUNTING_SECTOR, HEALTH_CARE_SECTOR, INFORMATION_SECTOR, MANAGEMENT_OF_COMPANIES_SECTOR, MANUFACTURING_SECTOR, MINING_QUARRYING_OIL_AND_GAS_SECTOR, OTHER_SERVICES_SECTOR, PUBLIC_ADMINISTRATION_SECTOR, REAL_ESTATE_SECTOR, RETAIL_TRADE_SECTOR, SCIENTIFIC_SERVICES_SECTOR, TRANSPORTATION_AND_WAREHOUSING_SECTOR, UTILITIES_SECTOR, WHOLESALE_TRADE_SECTOR } from "./industrySectorOptions";

export const CROP_PRODUCTION_SUB_SECTOR = '111';
export const ANIMAL_AND_AGRICULTURE_SUB_SECTOR = '112';
export const FORESTRY_AND_LOGGING_SUB_SECTOR = '113';
export const FISHING_HUNTING_TRAPPING_SUB_SECTOR = '114';
export const AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR = '115';
export const OIL_GAS_EXTRACTION_SUB_SECTOR = '211';
export const MINING_SUB_SECTOR = '212';
export const MINING_SUPPORT_ACTIVITIES_SUB_SECTOR = '213';
export const BUILDING_CONSTRUCTION_SUB_SECTOR = '236';
export const HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR = '237';
export const SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR = '238';
export const FOOD_MANUFACTURING_SUB_SECTOR = '311';
export const BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR = '312';
export const TEXTILE_MILLS_SUB_SECTOR = '313';
export const TEXTILE_PRODUCT_MILLS_SUB_SECTOR = '314';
export const APPAREL_MANUFACTURING_SUB_SECTOR = '315';
export const LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR = '316';
export const WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR = '321';
export const PAPER_MANUFACTURING_SUB_SECTOR = '322';
export const PRINTING_MANUFACTURING_SUB_SECTOR = '323';
export const PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR = '324';
export const CHEMICAL_MANUFACTURING_SUB_SECTOR = '325';
export const PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR = '326';
export const NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR = '327';
export const PRIMARY_METAL_MANUFACTURING_SUB_SECTOR = '331';
export const FABRICATED_METAL_MANUFACTURING_SUB_SECTOR = '332';
export const MACHINERY_MANUFACTURING_SUB_SECTOR = '333';
export const COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR = '334';
export const ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR = '335';
export const TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR = '336';
export const FURNITURE_MANUFACTURING_SUB_SECTOR = '337';
export const MISCELLANEOUS_MANUFACTURING_SUB_SECTOR = '339';
export const DURABLE_GOODS_SUB_SECTOR = '423';
export const NONDURABLE_GOODS_SUB_SECTOR = '424';
export const AGENTS_AND_BROKERS_SUB_SECTOR = '425';
export const MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR = '441';
export const BUILDING_MATERIAL_DEALERS_SUB_SECTOR = '444';
export const FOOD_RETAILERS_SUB_SECTOR = '445';
export const FURNITURE_RETAILERS_SUB_SECTOR = '449';
export const MERCHANDISE_RETAILERS_SUB_SECTOR = '455';
export const HEALTH_RETAILERS_SUB_SECTOR = '456';
export const GASOLINE_DEALERS_SUB_SECTOR = '457';
export const CLOTHING_RETAILERS_SUB_SECTOR = '458';
export const SPORTING_GOODS_RETAILERS_SUB_SECTOR = '459';
export const AIR_TRANSPORTATION_SUB_SECTOR = '481';
export const RAIL_TRANSPORTATION_SUB_SECTOR = '482';
export const WATER_TRANSPORTATION_SUB_SECTOR = '483';
export const TRUCK_TRANSPORTATION_SUB_SECTOR = '484';
export const TRANSIT_TRANSPORTATION_SUB_SECTOR = '485';
export const PIPELINE_TRANSPORTATION_SUB_SECTOR = '486';
export const SCENIC_TRANSPORTATION_SUB_SECTOR = '487';
export const SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR = '488';
export const POSTAL_SERVICE_SUB_SECTOR = '491';
export const COURIERS_SUB_SECTOR = '492';
export const WAREHOUSING_AND_STORAGE_SUB_SECTOR = '493';
export const MOTION_PIC_INDUSTRIES_SUB_SECTOR = '512';
export const PUBLISHING_INDUSTRIES_SUB_SECTOR = '513';
export const BROADCASTING_PROVIDER_SUB_SECTOR = '516';
export const TELECOMMUNICATION_SUB_SECTOR = '517';
export const COMPUTING_INFRASTRUCTURE_SUB_SECTOR = '518';
export const WEB_SEARCH_PORTALS_SUB_SECTOR = '519';
export const MONETARY_BANK_SUB_SECTOR = '521';
export const CREDIT_INTERMEDIATION_SUB_SECTOR = '522';
export const SECURITIES_COMMODITY_SUB_SECTOR = '523';
export const INSURANCE_CARRIERS_SUB_SECTOR = '524';
export const FUNDS_TRUSTS_SUB_SECTOR = '525';
export const REAL_ESTATE_SUB_SECTOR = '531';
export const RENTAL_AND_LEASING_SUB_SECTOR = '532';
export const LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR = '533';
export const ADMINISTRATIVE_SERVICE_SUB_SECTOR = '561';
export const WASTE_MANAGEMENT_SUB_SECTOR = '562';
export const EDUCATIONAL_SERVICES_SUB_SECTOR = '611';
export const AMBULATORY_CARE_SUB_SECTOR = '621';
export const HOSPITALS_SUB_SECTOR = '622';
export const NURSING_FACILITIES_SUB_SECTOR = '623';
export const SOCIAL_ASSISTANCE_SUB_SECTOR = '624';
export const PERFORMING_ARTS_SUB_SECTOR = '711';
export const MUSEUMS_SUB_SECTOR = '712';
export const AMUSEMENT_INDUSTRY_SUB_SECTOR = '713';
export const ACCOMMODATION_SUB_SECTOR = '721';
export const FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR = '722';
export const REPAIR_AND_MAINTENANCE_SUB_SECTOR = '811';
export const LAUNDRY_SERVICE_SUB_SECTOR = '812';
export const RELIGIOUS_SUB_SECTOR = '813';
export const PRIVATE_HOUSEHOLDS_SUB_SECTOR = '814';
export const EXECUTIVE_LEGISLATIVE_SUB_SECTOR = '921';
export const JUSTICE_PUBLIC_ORDER_SUB_SECTOR = '922';
export const ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR = '923';
export const ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR = '924';
export const ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR = '925';
export const ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR = '926';
export const SPACE_RESEARCH_SUB_SECTOR = '927';
export const NATIONAL_SECURITY_SUB_SECTOR = '928';

export const SUB_SECTOR_OPTIONS = {
  [FISHING_AND_HUNTING_SECTOR]: [
    { value: CROP_PRODUCTION_SUB_SECTOR, label: 'Crop Production' },
    { value: ANIMAL_AND_AGRICULTURE_SUB_SECTOR, label: 'Animal Production and Aquaculture' },
    { value: FORESTRY_AND_LOGGING_SUB_SECTOR, label: 'Forestry and Logging' },
    { value: FISHING_HUNTING_TRAPPING_SUB_SECTOR, label: 'Fishing, Hunting and Trapping' },
    { value: AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR, label: 'Support Activities for Agriculture and Forestry' },
  ],
  [MINING_QUARRYING_OIL_AND_GAS_SECTOR]: [
    { value: OIL_GAS_EXTRACTION_SUB_SECTOR, label: 'Oil and Gas Extraction' },
    { value: MINING_SUB_SECTOR, label: 'Mining (except Oil and Gas)' },
    { value: MINING_SUPPORT_ACTIVITIES_SUB_SECTOR, label: 'Support Activities for Mining' },
  ],
  [UTILITIES_SECTOR]: [],
  [CONSTRUCTION_SECTOR]: [
    { value: BUILDING_CONSTRUCTION_SUB_SECTOR, label: 'Construction of Buildings' },
    { value: HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR, label: 'Heavy and Civil Engineering Construction' },
    { value: SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR, label: 'Specialty Trade Contractors' },
  ],
  [MANUFACTURING_SECTOR]: [
    { value: FOOD_MANUFACTURING_SUB_SECTOR, label: 'Food Manufacturing' },
    { value: BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR, label: 'Beverage and Tobacco Product Manufacturing' },
    { value: TEXTILE_MILLS_SUB_SECTOR, label: 'Textile Mills' },
    { value: TEXTILE_PRODUCT_MILLS_SUB_SECTOR, label: 'Textile Product Mills' },
    { value: APPAREL_MANUFACTURING_SUB_SECTOR, label: 'Apparel Manufacturing' },
    { value: LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR, label: 'Leather and Allied Product Manufacturing' },
    { value: WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR, label: 'Wood Product Manufacturing' },
    { value: PAPER_MANUFACTURING_SUB_SECTOR, label: 'Paper Manufacturing' },
    { value: PRINTING_MANUFACTURING_SUB_SECTOR, label: 'Printing and Related Support Activities' },
    { value: PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR, label: 'Petroleum and Coal Products Manufacturing' },
    { value: CHEMICAL_MANUFACTURING_SUB_SECTOR, label: 'Chemical Manufacturing' },
    { value: PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR, label: 'Plastics and Rubber Products Manufacturing' },
    { value: NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR, label: 'Nonmetallic Mineral Product Manufacturing' },
    { value: PRIMARY_METAL_MANUFACTURING_SUB_SECTOR, label: 'Primary Metal Manufacturing' },
    { value: FABRICATED_METAL_MANUFACTURING_SUB_SECTOR, label: 'Fabricated Metal Product Manufacturing' },
    { value: MACHINERY_MANUFACTURING_SUB_SECTOR, label: 'Machinery Manufacturing' },
    { value: COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR, label: 'Computer and Electronic Product Manufacturing' },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
      label: 'Electrical Equipment, Appliance, and Component Manufacturing',
    },
    { value: TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR, label: 'Transportation Equipment Manufacturing' },
    { value: FURNITURE_MANUFACTURING_SUB_SECTOR, label: 'Furniture and Related Product Manufacturing' },
    { value: MISCELLANEOUS_MANUFACTURING_SUB_SECTOR, label: 'Miscellaneous Manufacturing' },
  ],
  [WHOLESALE_TRADE_SECTOR]: [
    { value: DURABLE_GOODS_SUB_SECTOR, label: 'Merchant Wholesalers, Durable Goods' },
    { value: NONDURABLE_GOODS_SUB_SECTOR, label: 'Merchant Wholesalers, Nondurable Goods' },
    { value: AGENTS_AND_BROKERS_SUB_SECTOR, label: 'Wholesale Trade Agents and Brokers' },
  ],
  [RETAIL_TRADE_SECTOR]: [
    { value: MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR, label: 'Motor Vehicle and Parts Dealers' },
    {
      value: BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
      label: 'Building Material and Garden Equipment and Supplies Dealers',
    },
    { value: FOOD_RETAILERS_SUB_SECTOR, label: 'Food and Beverage Retailers' },
    {
      value: FURNITURE_RETAILERS_SUB_SECTOR,
      label: 'Furniture, Home Furnishings, Electronics, and Appliance Retailers',
    },
    { value: MERCHANDISE_RETAILERS_SUB_SECTOR, label: 'General Merchandise Retailers' },
    { value: HEALTH_RETAILERS_SUB_SECTOR, label: 'Health and Personal Care Retailers' },
    { value: GASOLINE_DEALERS_SUB_SECTOR, label: 'Gasoline Stations and Fuel Dealers ' },
    { value: CLOTHING_RETAILERS_SUB_SECTOR, label: 'Clothing, Clothing Accessories, Shoe, and Jewelry Retailers' },
    {
      value: SPORTING_GOODS_RETAILERS_SUB_SECTOR,
      label: 'Sporting Goods, Hobby, Musical Instrument, Book, and Miscellaneous Retailers',
    },
  ],
  [TRANSPORTATION_AND_WAREHOUSING_SECTOR]: [
    { value: AIR_TRANSPORTATION_SUB_SECTOR, label: 'Air Transportation' },
    { value: RAIL_TRANSPORTATION_SUB_SECTOR, label: 'Rail Transportation' },
    { value: WATER_TRANSPORTATION_SUB_SECTOR, label: 'Water Transportation' },
    { value: TRUCK_TRANSPORTATION_SUB_SECTOR, label: 'Truck Transportation' },
    { value: TRANSIT_TRANSPORTATION_SUB_SECTOR, label: 'Transit and Ground Passenger Transportation' },
    { value: PIPELINE_TRANSPORTATION_SUB_SECTOR, label: 'Pipeline Transportation' },
    { value: SCENIC_TRANSPORTATION_SUB_SECTOR, label: 'Scenic and Sightseeing Transportation' },
    { value: SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR, label: 'Support Activities for Transportation' },
    { value: POSTAL_SERVICE_SUB_SECTOR, label: 'Postal Service' },
    { value: COURIERS_SUB_SECTOR, label: 'Couriers and Messengers' },
    { value: WAREHOUSING_AND_STORAGE_SUB_SECTOR, label: 'Warehousing and Storage' },
  ],
  [INFORMATION_SECTOR]: [
    { value: MOTION_PIC_INDUSTRIES_SUB_SECTOR, label: 'Motion Picture and Sound Recording Industries' },
    { value: PUBLISHING_INDUSTRIES_SUB_SECTOR, label: 'Publishing Industries' },
    { value: BROADCASTING_PROVIDER_SUB_SECTOR, label: 'Broadcasting and Content Providers' },
    { value: TELECOMMUNICATION_SUB_SECTOR, label: 'Telecommunications' },
    {
      value: COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
      label: 'Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services',
    },
    {
      value: WEB_SEARCH_PORTALS_SUB_SECTOR,
      label: 'Web Search Portals, Libraries, Archives, and Other Information Services',
    },
  ],
  [FINANCE_AND_INSURANCE_SECTOR]: [
    { value: MONETARY_BANK_SUB_SECTOR, label: 'Monetary Authorities-Central Bank' },
    { value: CREDIT_INTERMEDIATION_SUB_SECTOR, label: 'Credit Intermediation and Related Activities' },
    {
      value: SECURITIES_COMMODITY_SUB_SECTOR,
      label: 'Securities, Commodity Contracts, and Other Financial Investments and Related Activities',
    },
    { value: INSURANCE_CARRIERS_SUB_SECTOR, label: 'Insurance Carriers and Related Activities' },
    { value: FUNDS_TRUSTS_SUB_SECTOR, label: 'Funds, Trusts, and Other Financial Vehicles' },
  ],
  [REAL_ESTATE_SECTOR]: [
    { value: REAL_ESTATE_SUB_SECTOR, label: 'Real Estate' },
    { value: RENTAL_AND_LEASING_SUB_SECTOR, label: 'Rental and Leasing Services' },
    {
      value: LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
      label: 'Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)',
    },
  ],
  [SCIENTIFIC_SERVICES_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
  [ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR]: [
    { value: ADMINISTRATIVE_SERVICE_SUB_SECTOR, label: 'Administrative and Support Services' },
    { value: WASTE_MANAGEMENT_SUB_SECTOR, label: 'Waste Management and Remediation Services' },
  ],
  [EDUCATIONAL_SERVICES_SECTOR]: [{ value: EDUCATIONAL_SERVICES_SUB_SECTOR, label: 'Educational Services' }],
  [HEALTH_CARE_SECTOR]: [
    { value: AMBULATORY_CARE_SUB_SECTOR, label: 'Ambulatory Health Care Services' },
    { value: HOSPITALS_SUB_SECTOR, label: 'Hospitals' },
    { value: NURSING_FACILITIES_SUB_SECTOR, label: 'Nursing and Residential Care Facilities' },
    { value: SOCIAL_ASSISTANCE_SUB_SECTOR, label: 'Social Assistance' },
  ],
  [ARTS_ENTERTAINMENT_SECTOR]: [
    { value: PERFORMING_ARTS_SUB_SECTOR, label: 'Performing Arts, Spectator Sports, and Related Industries' },
    { value: MUSEUMS_SUB_SECTOR, label: 'Museums, Historical Sites, and Similar Institutions' },
    { value: AMUSEMENT_INDUSTRY_SUB_SECTOR, label: 'Amusement, Gambling, and Recreation Industries' },
  ],
  [ACCOMMODATION_SERVICES_SECTOR]: [
    { value: ACCOMMODATION_SUB_SECTOR, label: 'Accommodation' },
    { value: FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR, label: 'Food Services and Drinking Places' },
  ],
  [OTHER_SERVICES_SECTOR]: [
    { value: REPAIR_AND_MAINTENANCE_SUB_SECTOR, label: 'Repair and Maintenance' },
    { value: LAUNDRY_SERVICE_SUB_SECTOR, label: 'Personal and Laundry Services' },
    { value: RELIGIOUS_SUB_SECTOR, label: 'Religious, Grantmaking, Civic, Professional, and Similar Organizations' },
    { value: PRIVATE_HOUSEHOLDS_SUB_SECTOR, label: 'Private Households' },
  ],
  [PUBLIC_ADMINISTRATION_SECTOR]: [
    { value: EXECUTIVE_LEGISLATIVE_SUB_SECTOR, label: 'Executive, Legislative, and Other General Government Support' },
    { value: JUSTICE_PUBLIC_ORDER_SUB_SECTOR, label: 'Justice, Public Order, and Safety Activities' },
    { value: ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR, label: 'Administration of Human Resource Programs ' },
    {
      value: ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
      label: 'Administration of Environmental Quality Programs ',
    },
    {
      value: ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
      label: 'Administration of Housing Programs, Urban Planning, and Community Development',
    },
    { value: ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR, label: 'Administration of Economic Programs' },
    { value: SPACE_RESEARCH_SUB_SECTOR, label: 'Space Research and Technology' },
    { value: NATIONAL_SECURITY_SUB_SECTOR, label: 'National Security and International Affairs' },
  ],
};